__turbopack_context__.v({
  "contentWrapper": "step2-module__XlRzeq__contentWrapper",
  "main": "step2-module__XlRzeq__main",
  "resendBtn": "step2-module__XlRzeq__resendBtn",
  "resendTxt": "step2-module__XlRzeq__resendTxt",
  "sendWrapper": "step2-module__XlRzeq__sendWrapper",
  "timer": "step2-module__XlRzeq__timer",
});
